import { useEffect, useRef, useState } from "react";

// Hook that subscribes to /api/rikshaws/stream (SSE) and yields events.
export const useRikshawStream = (onEvent) => {
  const esRef = useRef(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/rikshaws/stream`;
    const es = new EventSource(url);
    esRef.current = es;
    es.onopen = () => setConnected(true);
    es.onerror = () => setConnected(false);
    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (onEvent) onEvent(data);
      } catch (err) {
        /* ignore */
      }
    };
    return () => {
      es.close();
      esRef.current = null;
    };
    // we intentionally don't re-subscribe on onEvent change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { connected };
};
